import { FC, ReactNode } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@src/lib/ui/AlertDialog";
import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  itemName?: string;
  onArchive: () => void;
  loading?: boolean;
  itemCount?: number;
  includeModuleCopy?: boolean;
  description?: ReactNode;
  confirmLabel?: string;
};

const ArchiveConfirmationDialog: FC<Props> = ({
  open,
  onOpenChange,
  title,
  itemName,
  onArchive,
  loading,
  itemCount = 1,
  includeModuleCopy = false,
  description,
  confirmLabel = "Archive",
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
        </AlertDialogHeader>
        <div className="flex flex-col">
          <Text variant="compact-description" multiline>
            {description ?? (
              <>
                {itemName && (
                  <>
                    Are you sure you want to archive <b>{itemName}</b>?
                    <br />
                    <br />
                  </>
                )}
                {itemCount === 1 ? "It" : `${itemCount} items`} will be removed
                from your library, but you'll still be able to find{" "}
                {itemCount === 1 ? "it" : "them"} under the Settings {">"}{" "}
                Archive tab.
                {includeModuleCopy && (
                  <>
                    <br />
                    <br />
                    If this content is inside a module, it will be removed from
                    the module as well.
                  </>
                )}
              </>
            )}
          </Text>
        </div>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onArchive();
              onOpenChange(false);
            }}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ArchiveConfirmationDialog;
